import { render, staticRenderFns } from "./PaywallFooterCta.vue?vue&type=template&id=16af74f8&scoped=true&"
import script from "./PaywallFooterCta.vue?vue&type=script&lang=ts&"
export * from "./PaywallFooterCta.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallFooterCta.vue?vue&type=style&index=0&id=16af74f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af74f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16af74f8', component.options)
    } else {
      api.reload('16af74f8', component.options)
    }
    module.hot.accept("./PaywallFooterCta.vue?vue&type=template&id=16af74f8&scoped=true&", function () {
      api.rerender('16af74f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PaywallFooterCta.vue"
export default component.exports